// pinyin.toml
var pinyin_default = {
	"0": { color: "gray" },
	"1": { color: "red" },
	"2": { color: "green" },
	"3": { color: "blue" },
	"4": { color: "purple" },
	a: {
		ipa: "a",
		term: "[a]lligator",
		done: true
	},
	ai: {
		ipa: "aɪ",
		term: "[eye]ball",
		done: true
	},
	an: {
		ipa: "an",
		term: "[an]nouncer",
		done: true
	},
	ang: {
		ipa: "ɑŋ",
		term: "g[ong]",
		done: true
	},
	ao: {
		ipa: "aʊ",
		term: "[ou]tlet",
		done: true
	},
	ba: {
		ipa: "pa",
		term: "[ba]llerina",
		done: true
	},
	bai: {
		ipa: "paɪ",
		term: "ra[bbi]",
		done: true
	},
	ban: {
		ipa: "pan",
		term: "[bun]ny",
		done: true
	},
	bang: {
		ipa: "pɑŋ",
		term: "[bong]o cat",
		done: true
	},
	bao: {
		ipa: "paʊ",
		term: "[ba]ll",
		done: true
	},
	bei: {
		ipa: "peɪ",
		term: ["[ba]by", "[ba]bies"],
		done: true
	},
	ben: {
		ipa: "pən",
		term: "[bin]",
		done: true
	},
	beng: {
		ipa: "pəŋ",
		term: "[bung]alow",
		done: true
	},
	bi: {
		ipa: "pi",
		term: ["[bee]", "[bee]s"],
		done: true
	},
	bian: {
		ipa: "pjɛn",
		term: "amphi[bian]",
		done: true
	},
	biao: {
		ipa: "pjaʊ",
		term: "ba[by ow]l",
		done: true
	},
	bie: {
		ipa: "pje",
		term: "ba[by i]guana",
		done: true
	},
	bin: {
		ipa: "pin",
		term: "[bean]ie",
		done: true
	},
	bing: {
		ipa: "piŋ",
		term: "[bean g]rinder",
		done: true
	},
	bo: {
		ipa: "pwo",
		term: "su[bwo]ofer",
		done: true
	},
	bu: {
		ipa: "pu",
		term: "[boo]t",
		done: true
	},
	ca: {
		ipa: "ʦʰa",
		term: "ho[t sa]lami"
	},
	cai: {
		ipa: "ʦʰaɪ",
		term: "ou[tsi]de",
		done: true
	},
	can: {
		ipa: "ʦʰan",
		term: "ho[t sun]"
	},
	cang: {
		ipa: "ʦʰɑŋ",
		term: "hi[t song]writer"
	},
	cao: {
		ipa: "ʦʰaʊ",
		term: "stree[t sa]lt",
		done: true
	},
	ce: {
		ipa: "ʦʰɤ",
		term: "ho[t su]pper"
	},
	cen: {
		ipa: "ʦʰən",
		term: "Yel[tsin]"
	},
	ceng: {
		ipa: "ʦʰəŋ",
		term: "spor[t sung]lasses",
		done: true
	},
	cha: {
		ipa: "ʈʂʰa",
		term: "[cha]lice",
		type: "noun"
	},
	chai: {
		ipa: "ʈʂʰaɪ",
		term: "[chai] tea",
		done: true
	},
	chan: {
		ipa: "ʈʂʰan",
		term: "[chan]cellor"
	},
	chang: {
		ipa: "ʈʂʰɑŋ",
		term: "ri[ch en]trepreneur",
		done: true
	},
	chao: {
		ipa: "ʈʂʰaʊ",
		term: "clam [chow]der",
		done: true
	},
	che: {
		ipa: "ʈʂʰɤ",
		term: "[chu]ck norris",
		done: true
	},
	chen: {
		ipa: "ʈʂʰən",
		term: "[chin]",
		type: "noun"
	},
	cheng: {
		ipa: "ʈʂʰəŋ",
		term: "[chung]us",
		done: true
	},
	chi: {
		ipa: "ʈʂʰɻ̩",
		term: "[chi]huahua",
		done: true
	},
	chong: {
		ipa: "ʈʂʰʊŋ",
		term: "wat[ch own g]oal scorer"
	},
	chou: {
		ipa: "ʈʂʰoʊ",
		term: "arti[cho]ke",
		done: true
	},
	chu: {
		ipa: "ʈʂʰu",
		term: "rai[chu]",
		done: true
	},
	chuai: {
		ipa: "ʈʂʰwaɪ",
		term: "hat[ch wi]per"
	},
	chuan: {
		ipa: "ʈʂʰwan",
		term: "mat[ch one]"
	},
	chuang: {
		ipa: "ʈʂʰwɑŋ",
		term: "coa[ch wong]"
	},
	chui: {
		ipa: "ʈʂʰweɪ",
		term: "ar[chway]"
	},
	chun: {
		ipa: "ʈʂʰwən",
		term: "mat[ch win]ner",
		done: true
	},
	chuo: {
		ipa: "ʈʂʰwo",
		term: "bir[ch wo]od",
		done: true
	},
	ci: {
		ipa: "ʦʰɹ̩",
		term: "ba[ts]"
	},
	cong: {
		ipa: "ʦʰʊŋ",
		term: "i[t's own g]oals"
	},
	cou: {
		ipa: "ʦʰoʊ",
		term: "fa[tso]",
		done: true
	},
	cu: {
		ipa: "ʦʰu",
		term: "sa[tsu]ma",
		done: true
	},
	cuan: {
		ipa: "ʦʰwan",
		term: "[t's one]"
	},
	cui: {
		ipa: "ʦʰweɪ",
		term: "[t's way]"
	},
	cun: {
		ipa: "ʦʰwən",
		term: "[ts win]"
	},
	cuo: {
		ipa: "ʦʰwo",
		term: "spor[tswo]man",
		type: "noun"
	},
	da: {
		ipa: "ta",
		term: "[da]lmatian"
	},
	dai: {
		ipa: "taɪ",
		term: ["[di]e", "[di]ce"],
		done: true
	},
	dan: {
		ipa: "tan",
		term: "[dun]geon"
	},
	dang: {
		ipa: "tɑŋ",
		term: "[dong]le",
		done: true
	},
	dao: {
		ipa: "taʊ",
		term: "[dal]matian",
		done: true
	},
	de: {
		ipa: "tɤ",
		term: "[du]ck",
		done: true
	},
	dei: {
		ipa: "teɪ",
		term: "[dai]sy",
		done: true
	},
	den: {
		ipa: "tən",
		term: "[din]ner",
		done: true
	},
	deng: {
		ipa: "təŋ",
		term: "[dung]",
		done: true
	},
	di: {
		ipa: "ti",
		term: "[dee]r",
		done: true
	},
	dian: {
		ipa: "tjɛn",
		term: "come[dian]",
		done: true
	},
	diao: {
		ipa: "tjaʊ",
		term: "can[dy ou]tlet"
	},
	die: { ipa: "tje" },
	ding: {
		ipa: "tiŋ",
		term: "squi[d in]k",
		done: true
	},
	diu: {
		ipa: "tjoʊ",
		term: "ra[dio]"
	},
	dong: {
		ipa: "tʊŋ",
		term: "con[done g]un"
	},
	dou: {
		ipa: "toʊ",
		term: "[do]nut"
	},
	du: {
		ipa: "tu",
		term: "[doo]dle"
	},
	duan: {
		ipa: "twan",
		term: "worl[d won]der"
	},
	dui: {
		ipa: "tweɪ",
		term: "foo[d wa]ste",
		done: true
	},
	dun: {
		ipa: "twən",
		term: "[dune]"
	},
	duo: {
		ipa: "two",
		term: "ma[dwo]man"
	},
	e: {
		ipa: "ɤ",
		term: "[uh]"
	},
	en: {
		ipa: "ən",
		term: "[en]emy",
		done: true
	},
	er: {
		ipa: "ɚ",
		term: "[ar]tist",
		done: true
	},
	fa: {
		ipa: "fa",
		term: "al[pha] male",
		type: "noun"
	},
	fan: {
		ipa: "fan",
		term: "[fun]"
	},
	fang: {
		ipa: "fɑŋ",
		term: "bee[f ong]let"
	},
	fei: {
		ipa: "feɪ",
		term: "[fa]ke"
	},
	fen: {
		ipa: "fən",
		term: ["dol[phin]", "dol[phin]s"],
		done: true
	},
	feng: {
		ipa: "fəŋ",
		term: ["[fung]us", "[fung]i"],
		done: true
	},
	fo: {
		ipa: "fwo",
		term: "hal[f-wo]man"
	},
	fou: {
		ipa: "foʊ",
		term: ["[pho]to", "[pho]tos"],
		done: true
	},
	fu: {
		ipa: "fu",
		term: "[foo]d"
	},
	ga: {
		ipa: "ka",
		term: "[ga]-ga"
	},
	gai: {
		ipa: "kaɪ",
		term: "[gey]ser",
		done: true
	},
	gan: {
		ipa: "kan",
		term: ["[gun]", "[gun]s"],
		done: true
	},
	gang: {
		ipa: "kɑŋ",
		term: "[gong]",
		done: true
	},
	gao: {
		ipa: "kaʊ",
		term: "[Gau]ss",
		done: true
	},
	ge: {
		ipa: "kɤ",
		term: "[gu]sh"
	},
	gei: { ipa: "keɪ" },
	gen: {
		ipa: "kən",
		term: "dra[gon]",
		done: true
	},
	geng: {
		ipa: "kəŋ",
		term: "[gun]k",
		done: true
	},
	gong: {
		ipa: "kʊŋ",
		term: "[goan g]ravy"
	},
	gou: {
		ipa: "koʊ",
		term: ["[gho]st", "[gho]sts"],
		done: true
	},
	gu: {
		ipa: "ku",
		term: "[goo]se",
		done: true
	},
	gua: {
		ipa: "kwa",
		term: "[gua]va"
	},
	guai: {
		ipa: "kwaɪ",
		term: "fo[g wi]per"
	},
	guan: {
		ipa: "kwan",
		term: "do[g one]sie"
	},
	guang: {
		ipa: "kwɑŋ",
		term: "kin[g Wong]",
		done: true
	},
	gui: {
		ipa: "kweɪ",
		term: "se[gway]",
		done: true
	},
	gun: {
		ipa: "kwən",
		term: "[goon]"
	},
	guo: {
		ipa: "kwo",
		term: "bi[g wo]rm"
	},
	ha: {
		ipa: "xa",
		term: "[ha]-ha"
	},
	hai: {
		ipa: "xaɪ",
		term: "[high]way"
	},
	han: {
		ipa: "xan",
		term: "[hun]ter",
		done: true
	},
	hang: {
		ipa: "xɑŋ",
		term: "[hon]k"
	},
	hao: {
		ipa: "xaʊ",
		term: "[hou]se",
		done: true
	},
	he: {
		ipa: "xɤ",
		term: "[hu]t"
	},
	hei: {
		ipa: "xeɪ",
		term: "[hay]"
	},
	hen: {
		ipa: "xən",
		term: "[hin]t"
	},
	heng: {
		ipa: "xəŋ",
		term: "[hung]ry"
	},
	hong: {
		ipa: "xʊŋ",
		term: "[honed g]ranite"
	},
	hou: {
		ipa: "xoʊ",
		term: "[hoe]",
		done: true
	},
	hu: {
		ipa: "xu",
		term: "[hoo]p",
		done: true
	},
	hua: {
		ipa: "xwa",
		term: "Ya[hoo o]ffice"
	},
	huai: {
		ipa: "xwaɪ",
		term: "Oa[hu i]sland",
		done: true
	},
	huan: {
		ipa: "xwan",
		term: "Boo[hoo On]ion"
	},
	huang: {
		ipa: "xwɑŋ",
		term: "[Who en]semble"
	},
	hui: {
		ipa: "xweɪ",
		term: "Doctor [Who a]liens"
	},
	hun: {
		ipa: "xwən",
		term: "Ya[hoo in]tern",
		done: true
	},
	huo: {
		ipa: "xwo",
		term: "Boo[hoo Wo]man"
	},
	ji: {
		ipa: "ʨi",
		term: ["[Je]ep", "[Je]eps"],
		done: true
	},
	jia: {
		ipa: "ʨja",
		term: "veg[gie a]ppetizer",
		donue: true
	},
	jian: {
		ipa: "ʨjɛn",
		term: "[gee en]vy"
	},
	jiang: {
		ipa: "ʨjɑŋ",
		term: "[gee ong]"
	},
	jiao: {
		ipa: "ʨjaʊ",
		term: "pud[gy ow]let"
	},
	jie: {
		ipa: "ʨje",
		term: "[ji]gsaw",
		done: true
	},
	jin: {
		ipa: "ʨin",
		term: "[jean]s",
		done: true
	},
	jing: {
		ipa: "ʨiŋ",
		term: "[jing]le"
	},
	jiong: {
		ipa: "ʨjʊŋ",
		term: "crin[gy own g]oal scorer"
	},
	jiu: {
		ipa: "ʨjoʊ",
		term: "[geo]dude",
		done: true
	},
	ju: {
		ipa: "ʨy",
		term: "[ju]ry"
	},
	juan: {
		ipa: "ʨɥɛn",
		term: "[ju when]"
	},
	jue: {
		ipa: "ʨɥe",
		term: "[ju i]t"
	},
	jun: {
		ipa: "ʨyn",
		term: "[june]"
	},
	ka: {
		ipa: "kʰa",
		term: "[co]ffee"
	},
	kai: {
		ipa: "kʰaɪ",
		term: "[ki]te",
		done: true
	},
	kan: {
		ipa: "kʰan",
		term: "[cun]ning"
	},
	kang: {
		ipa: "kʰɑŋ",
		term: "[cong]o"
	},
	kao: {
		ipa: "kʰaʊ",
		term: "ta[keou]t",
		done: true
	},
	ke: {
		ipa: "kʰɤ",
		term: "[cu]p",
		done: true
	},
	ken: {
		ipa: "kʰən",
		term: "kra[ken]",
		done: true
	},
	keng: {
		ipa: "kʰəŋ",
		term: "[kung]fu",
		done: true
	},
	kong: {
		ipa: "kʰʊŋ",
		term: "sili[cone g]lue"
	},
	kou: {
		ipa: "kʰoʊ",
		term: "[co]bra",
		done: true
	},
	ku: {
		ipa: "kʰu",
		term: "[koo]laid",
		done: true
	},
	kua: {
		ipa: "kʰwa",
		term: "[qua]d"
	},
	kuai: {
		ipa: "kʰwaɪ",
		term: "[kawai]i"
	},
	kuan: {
		ipa: "kʰwan",
		term: "wee[k one]"
	},
	kuang: {
		ipa: "kʰwɑŋ",
		term: "mon[k Wong]",
		done: true
	},
	kui: {
		ipa: "kʰweɪ",
		term: "bac[k way]"
	},
	kun: {
		ipa: "kʰwən",
		term: "co[coon]",
		done: true
	},
	kuo: {
		ipa: "kʰwo",
		term: "bac[k wo]man"
	},
	la: {
		ipa: "la",
		term: "[la]sso"
	},
	lai: {
		ipa: "laɪ",
		term: "[lie]"
	},
	lan: {
		ipa: "lan",
		term: "[lun]cheon"
	},
	lang: {
		ipa: "lɑŋ",
		term: "[long]"
	},
	lao: {
		ipa: "laʊ",
		term: "[lou]sy"
	},
	le: {
		ipa: "lɤ",
		term: "[lu]ck"
	},
	lei: {
		ipa: "leɪ",
		term: "[lay]"
	},
	leng: {
		ipa: "ləŋ",
		term: "[lung]"
	},
	li: {
		ipa: "li",
		term: "de[li]"
	},
	lia: {
		ipa: "lja",
		term: "ci[lia]"
	},
	lian: {
		ipa: "ljɛn",
		term: "a[lien]"
	},
	liang: {
		ipa: "ljɑŋ",
		term: "nuc[leon]"
	},
	liao: {
		ipa: "ljaʊ",
		term: "ow[ly ow]l"
	},
	lie: {
		ipa: "lje",
		term: "[ly e]"
	},
	lin: {
		ipa: "lin",
		term: "[lean]"
	},
	ling: {
		ipa: "liŋ",
		term: "s[ling]shot"
	},
	liu: {
		ipa: "ljoʊ",
		term: "fo[lio]"
	},
	long: {
		ipa: "lʊŋ",
		term: "[loan g]uarantor"
	},
	lou: {
		ipa: "loʊ",
		term: "[low]"
	},
	lu: {
		ipa: "lu",
		term: "ig[loo]"
	},
	"lü": {
		ipa: "lɥ",
		term: "[lu]re",
		done: true
	},
	luan: {
		ipa: "lwan",
		term: "b[lue un]derwear"
	},
	"lüe": {
		ipa: "lɥe",
		term: "b[lue ye]ti"
	},
	lun: {
		ipa: "lwən",
		term: ["bal[loon]", "bal[loons]"],
		done: true
	},
	luo: {
		ipa: "lwo",
		term: "b[lue a]larm"
	},
	m: {
		ipa: "m̩",
		term: "[mm]"
	},
	ma: {
		ipa: "ma",
		term: "[ma]raca",
		done: true
	},
	mai: {
		ipa: "maɪ",
		term: "ter[mi]te"
	},
	man: {
		ipa: "man",
		term: "[mun]dane"
	},
	mang: {
		ipa: "mɑŋ",
		term: ["[mon]key", "[mon]keys"],
		done: true
	},
	mao: {
		ipa: "maʊ",
		term: ["[mo]lecule", "[mo]lecules"],
		done: true
	},
	me: { ipa: "mɤ" },
	mei: {
		ipa: "meɪ",
		term: "[may]"
	},
	men: {
		ipa: "mən",
		term: "[min]t leaf",
		done: true
	},
	meng: {
		ipa: "məŋ",
		term: "a[mong] us",
		done: true
	},
	mi: {
		ipa: "mi",
		term: "[mi]so soup",
		done: true
	},
	mian: {
		ipa: "mjɛn",
		term: "bohe[mian]",
		done: true
	},
	miao: {
		ipa: "mjaʊ",
		term: "[meow]"
	},
	mie: {
		ipa: "mje",
		term: "roo[my i]gloo"
	},
	min: {
		ipa: "min",
		term: "[mean]"
	},
	ming: {
		ipa: "miŋ",
		term: "[mean g]irl"
	},
	miu: {
		ipa: "mjoʊ",
		term: "Ro[meo]",
		done: true
	},
	mo: {
		ipa: "mwo",
		term: "[m wo]man"
	},
	mou: {
		ipa: "moʊ",
		term: ["[mo]torboat", "[mo]torboats"],
		done: true
	},
	mu: {
		ipa: "mu",
		term: "[moo]shroom",
		done: true
	},
	na: {
		ipa: "na",
		term: "[na]-na"
	},
	nai: {
		ipa: "naɪ",
		term: "[knigh]t",
		done: true
	},
	nan: {
		ipa: "nan",
		term: ["[nun]", "[nun]chuck"],
		done: true
	},
	nang: {
		ipa: "nɑŋ",
		term: "[Nang]i",
		done: true
	},
	nao: {
		ipa: "naʊ",
		term: "[now]"
	},
	ne: {
		ipa: "nɤ",
		term: ["[nu]gget", "[nu]ggets"],
		done: true
	},
	nei: {
		ipa: "neɪ",
		term: ["[neigh]bour", "[neigh]bours"],
		done: true
	},
	nen: {
		ipa: "nən",
		term: ["[nin]ja", "[nin]jas"],
		done: true
	},
	neng: { ipa: "nəŋ" },
	ni: {
		ipa: "ni",
		term: ["[nee]dle", "[nee]dles"],
		done: true
	},
	nian: {
		ipa: "njɛn",
		term: ["mi[nion]", "mi[nion]s"],
		done: true
	},
	niang: {
		ipa: "njɑŋ",
		term: "[neon g]reen"
	},
	niao: {
		ipa: "njaʊ",
		term: "taw[ny ow]l"
	},
	nie: {
		ipa: "nje",
		term: "shi[ny e]merald"
	},
	nin: {
		ipa: "nin",
		term: "pa[nin]i",
		done: true
	},
	ning: {
		ipa: "niŋ",
		term: ["iro[n ing]ot", "iro[n ing]ots"],
		done: true
	},
	niu: {
		ipa: "njoʊ",
		term: "[Neo]",
		done: true
	},
	nong: {
		ipa: "nʊŋ",
		term: "un[known g]unman"
	},
	nou: {
		ipa: "noʊ",
		term: ["di[no]", "di[no]s"],
		done: true
	},
	nu: {
		ipa: "nu",
		term: ["[noo]dle", "[noo]dles"],
		done: true
	},
	"nü": {
		ipa: "nu",
		term: "[neu]ron"
	},
	nuan: { ipa: "nwan" },
	"nüe": {
		ipa: "nɥe",
		term: "bo[ny wi]tch"
	},
	nuo: {
		ipa: "nwo",
		term: "co[nwo]man"
	},
	o: {
		ipa: "o",
		term: "[o]"
	},
	ou: {
		ipa: "oʊ",
		term: "[owe]"
	},
	pa: {
		ipa: "pʰa",
		term: "pa[pa]"
	},
	pai: {
		ipa: "pʰaɪ",
		term: "[pie]",
		done: true
	},
	pan: {
		ipa: "pʰan",
		term: "[pun]"
	},
	pang: {
		ipa: "pʰɑŋ",
		term: "[pong]"
	},
	pao: {
		ipa: "pʰaʊ",
		term: "[pow]er"
	},
	pei: {
		ipa: "pʰeɪ",
		term: "[pay]phone",
		done: true
	},
	pen: {
		ipa: "pʰən",
		term: "[pin]"
	},
	peng: {
		ipa: "pʰəŋ",
		term: "[pung]ent"
	},
	pi: {
		ipa: "pʰi",
		term: "[pi]ano",
		done: true
	},
	pian: {
		ipa: "pʰjɛn",
		term: "sa[pien]"
	},
	piao: {
		ipa: "pʰjaʊ",
		term: "hap[py ow]l"
	},
	pie: {
		ipa: "pʰje",
		term: "hap[py ye]ti"
	},
	pin: {
		ipa: "pʰin",
		term: "[pean]ut",
		done: true
	},
	ping: {
		ipa: "pʰiŋ",
		term: "[peen g]old"
	},
	po: {
		ipa: "pʰwo",
		term: "pul[pwo]od"
	},
	pou: {
		ipa: "pʰoʊ",
		term: "[Po] Panda",
		done: true
	},
	pu: {
		ipa: "pʰu",
		term: "[poo]"
	},
	qi: {
		ipa: "ʨʰi",
		term: "ly[chee]"
	},
	qia: {
		ipa: "ʨʰja",
		term: "crun[chy a]pple"
	},
	qian: {
		ipa: "ʨʰjɛn",
		term: "sket[chy en]trance"
	},
	qiang: {
		ipa: "ʨʰjɑŋ",
		term: "cat[chy en]semble"
	},
	qiao: {
		ipa: "ʨʰjaʊ",
		term: "ly[chee hou]rglass"
	},
	qie: {
		ipa: "ʨʰje",
		term: "it[chy e]ti"
	},
	qin: {
		ipa: "ʨʰin",
		term: "cappu[ccin]o"
	},
	qing: {
		ipa: "ʨʰiŋ",
		term: "ka[ching]"
	},
	qiong: {
		ipa: "ʨʰjʊŋ",
		term: "[chee owng]oal"
	},
	qiu: {
		ipa: "ʨʰjoʊ",
		term: "carpa[ccio]"
	},
	qu: {
		ipa: "ʨʰy",
		term: "ri[ch E.U.]"
	},
	quan: {
		ipa: "ʨʰɥɛn",
		term: "bat[ch wen]dy"
	},
	que: {
		ipa: "ʨʰɥe",
		term: "bat[ch whi]ff"
	},
	qun: {
		ipa: "ʨʰyn",
		term: "mat[ch win]ner"
	},
	ran: {
		ipa: "ʐan",
		term: "[run]ner",
		done: true
	},
	rang: {
		ipa: "ʐɑŋ",
		term: "[wrong]"
	},
	rao: {
		ipa: "ʐaʊ",
		term: "[rou]ter"
	},
	re: {
		ipa: "ʐɤ",
		term: "[ru]ssia"
	},
	ren: {
		ipa: "ʐən",
		term: "[rin]se"
	},
	reng: {
		ipa: "ʐəŋ",
		term: "[rung]"
	},
	ri: {
		ipa: "ʐɻ̩",
		term: "[ir]k"
	},
	rong: {
		ipa: "ʐʊŋ",
		term: "[rown g]oat"
	},
	rou: {
		ipa: "ʐoʊ",
		term: "ar[row]",
		done: true
	},
	ru: {
		ipa: "ʐu",
		term: "[roo]ster",
		done: true
	},
	ruan: {
		ipa: "ʐwan",
		term: "[ran]"
	},
	rui: {
		ipa: "ʐweɪ",
		term: "x-[ray]",
		done: true
	},
	run: {
		ipa: "ʐwən",
		term: "[ruin]"
	},
	ruo: {
		ipa: "ʐwo",
		term: "[roa]r"
	},
	sa: {
		ipa: "sa",
		term: "[sa]lad",
		done: true
	},
	sai: {
		ipa: "saɪ",
		term: "[psy]duck",
		done: true
	},
	san: {
		ipa: "san",
		term: "[sun]",
		done: true
	},
	sang: {
		ipa: "sɑŋ",
		term: "[song]bird",
		done: true
	},
	sao: {
		ipa: "saʊ",
		term: "[sou]rdough",
		done: true
	},
	se: {
		ipa: "sɤ",
		term: "[su]"
	},
	sen: {
		ipa: "sən",
		term: "[cen]tipede",
		done: true
	},
	seng: {
		ipa: "səŋ",
		term: "[sung]"
	},
	sha: {
		ipa: "ʂa",
		term: "[sha]ft"
	},
	shai: {
		ipa: "ʂaɪ",
		term: "[shy] guy",
		done: true
	},
	shan: {
		ipa: "ʂan",
		term: "[shun]"
	},
	shang: {
		ipa: "ʂɑŋ",
		term: "fi[sh en]tree"
	},
	shao: {
		ipa: "ʂaʊ",
		term: "[show]er",
		type: "noun"
	},
	she: {
		ipa: "ʂɤ",
		term: "[sho]vel",
		done: true
	},
	shei: {
		ipa: "ʂeɪ",
		term: "[sha]de",
		done: true
	},
	shen: {
		ipa: "ʂən",
		term: "[shin]",
		done: true
	},
	sheng: {
		ipa: "ʂəŋ",
		term: "[shung]ite bracelet"
	},
	shi: {
		ipa: "ʂɻ̩",
		term: "[shi]rt",
		done: true
	},
	shou: {
		ipa: "ʂoʊ",
		term: "[show]",
		done: true
	},
	shu: {
		ipa: "ʂu",
		term: "[shoe]lace",
		done: true
	},
	shua: {
		ipa: "ʂwa",
		term: "di[shwa]sher",
		done: true
	},
	shuai: {
		ipa: "ʂwaɪ",
		term: "fi[shwi]fe"
	},
	shuan: {
		ipa: "ʂwan",
		term: "fi[sh one]sie"
	},
	shuang: {
		ipa: "ʂwɑŋ",
		term: "[sh won]g"
	},
	shui: {
		ipa: "ʂweɪ",
		term: "[shway]"
	},
	shun: {
		ipa: "ʂwən",
		term: "fre[sh un]agi"
	},
	shuo: {
		ipa: "ʂwo",
		term: "[shwa]rma",
		done: true
	},
	si: {
		ipa: "sɹ̩",
		term: "[s']more",
		done: true
	},
	song: {
		ipa: "sʊŋ",
		term: "[sown g]oose"
	},
	sou: {
		ipa: "soʊ",
		term: "[so]ber"
	},
	su: {
		ipa: "su",
		term: "[su]dan",
		done: true
	},
	suan: {
		ipa: "swan",
		term: "plu[s one]"
	},
	sui: {
		ipa: "sweɪ",
		term: "[sway]"
	},
	sun: {
		ipa: "swən",
		term: "bas[soon]",
		done: true
	},
	suo: {
		ipa: "swo",
		term: "[swo]rd",
		done: true
	},
	ta: {
		ipa: "tʰa",
		term: "[ta]ttoo",
		done: true
	},
	tai: {
		ipa: "tʰaɪ",
		term: "[ti]ger",
		done: true
	},
	tan: {
		ipa: "tʰan",
		term: "[Tun]dra"
	},
	tang: {
		ipa: "tʰɑŋ",
		term: "[tong]s",
		done: true
	},
	tao: {
		ipa: "tʰaʊ",
		term: "[to]wel",
		done: true
	},
	te: {
		ipa: "tʰɤ",
		term: "[to]uch"
	},
	teng: {
		ipa: "tʰəŋ",
		term: "[tongue]",
		done: true
	},
	ti: {
		ipa: "tʰi",
		term: "[tea]bag",
		done: true
	},
	tian: {
		ipa: "tʰjɛn",
		term: "guil[ty in]mate"
	},
	tiao: {
		ipa: "tʰjaʊ",
		term: "dir[ty out]house"
	},
	tie: {
		ipa: "tʰje",
		term: "[tea e]spresso",
		type: "noun"
	},
	ting: {
		ipa: "tʰiŋ",
		term: "[teen g]irl",
		done: true
	},
	tong: {
		ipa: "tʰʊŋ",
		term: "ace[tone g]as"
	},
	tou: {
		ipa: "tʰoʊ",
		term: "[tow] truck",
		done: true
	},
	tu: {
		ipa: "tʰu",
		term: ["[tu]lip", "[tu]lips"],
		done: true
	},
	tuan: {
		ipa: "tʰwan",
		term: "fa[t 1]"
	},
	tui: {
		ipa: "tʰweɪ",
		term: "foo[tway]"
	},
	tun: {
		ipa: "tʰwən",
		term: "[tun]dra"
	},
	tuo: {
		ipa: "tʰwo",
		term: "ba[two]man",
		type: "noun"
	},
	wa: {
		ipa: "wa",
		term: "[wa]ffle"
	},
	wai: {
		ipa: "waɪ",
		term: "[wi]re"
	},
	wan: {
		ipa: "wan",
		term: "[won]derland"
	},
	wang: {
		ipa: "wɑŋ",
		term: "willy [wonk]a"
	},
	wei: {
		ipa: "weɪ",
		term: "[wai]ter"
	},
	wen: {
		ipa: "wən",
		term: "[win]"
	},
	weng: {
		ipa: "wəŋ",
		term: "s[wung]"
	},
	wo: {
		ipa: "u̯ɔ",
		term: "[Wo]ody"
	},
	wu: {
		ipa: "u",
		term: "[u]don"
	},
	xi: {
		ipa: "ɕi",
		term: "[sea]"
	},
	xia: {
		ipa: "ɕja",
		term: "[sea]ttle"
	},
	xian: {
		ipa: "ɕjɛn",
		term: "[sea an]emone"
	},
	xiang: {
		ipa: "ɕjɑŋ",
		term: "mes[sy en]suite"
	},
	xiao: {
		ipa: "ɕjaʊ",
		term: "mes[sy out]let"
	},
	xie: {
		ipa: "ɕje",
		term: "noi[sy ye]ller"
	},
	xin: {
		ipa: "ɕin",
		term: "[scene]"
	},
	xing: {
		ipa: "ɕiŋ",
		term: "un[seen g]host"
	},
	xiong: {
		ipa: "ɕjʊŋ",
		term: "clum[sy own g]oal"
	},
	xiu: {
		ipa: "ɕjoʊ",
		term: "ca[sio]"
	},
	xu: {
		ipa: "ɕy",
		term: "Briti[sh Eu]ropean"
	},
	xuan: {
		ipa: "ɕɥɛn",
		term: "[shoe en]graving"
	},
	xue: {
		ipa: "ɕɥe",
		term: "tis[sue ]"
	},
	xun: {
		ipa: "ɕyn",
		term: "[shoe in]sole"
	},
	ya: {
		ipa: "ja",
		term: "papa[ya]"
	},
	yan: {
		ipa: "jɛn",
		term: "[yen]"
	},
	yang: {
		ipa: "jɑŋ",
		term: "[young]"
	},
	yao: {
		ipa: "jaʊ",
		term: "snow[y ow]l"
	},
	ye: {
		ipa: "je",
		term: "[ye]llow"
	},
	yi: {
		ipa: "i",
		term: "[e]mu"
	},
	yin: {
		ipa: "in",
		term: "gr[een]"
	},
	ying: {
		ipa: "iŋ",
		term: "[eng]lish"
	},
	yo: {
		ipa: "jo",
		term: "yuh"
	},
	yong: { ipa: "jʊŋ" },
	you: {
		ipa: "joʊ",
		term: "[yo]-yo"
	},
	yu: {
		ipa: "y",
		term: "[eu]rope"
	},
	yuan: {
		ipa: "ɥɛn",
		term: "[U.N.]"
	},
	yue: {
		ipa: "ɥe",
		term: "sho[yu e]gg"
	},
	yun: {
		ipa: "yn",
		term: "sho[yu inn]"
	},
	za: {
		ipa: "ʦa",
		term: "[d's a]"
	},
	zai: {
		ipa: "ʦaɪ",
		term: "bir[d's eye] view"
	},
	zan: {
		ipa: "ʦan",
		term: "re[d sun]"
	},
	zang: {
		ipa: "ʦɑŋ",
		term: "ban[d's en]tourage"
	},
	zao: {
		ipa: "ʦaʊ",
		term: "ki[ds ou]tside"
	},
	ze: {
		ipa: "ʦɤ",
		term: "gran[dso]n"
	},
	zei: {
		ipa: "ʦeɪ",
		term: "win[dsa]il"
	},
	zen: {
		ipa: "ʦən",
		term: "hu[dson] bay"
	},
	zeng: {
		ipa: "ʦəŋ",
		term: "da[d's un]cle"
	},
	zha: {
		ipa: "ʈʂa",
		term: "[ja]cket"
	},
	zhai: {
		ipa: "ʈʂaɪ",
		term: "[gi]ant"
	},
	zhan: {
		ipa: "ʈʂan",
		term: "[jun]to army"
	},
	zhang: {
		ipa: "ʈʂɑŋ",
		term: "[j un]cle"
	},
	zhao: {
		ipa: "ʈʂaʊ",
		term: "[jou]st"
	},
	zhe: {
		ipa: "ʈʂɤ",
		term: "[Ja]maican"
	},
	zhen: {
		ipa: "ʈʂən",
		term: "pi[geon]"
	},
	zheng: {
		ipa: "ʈʂəŋ",
		term: "[jung]le"
	},
	zhi: {
		ipa: "ʈʂɻ̩",
		term: "[gi]raffe"
	},
	zhong: { ipa: "ʈʂʊŋ" },
	zhou: {
		ipa: "ʈʂoʊ",
		term: "[Jo]ker"
	},
	zhu: {
		ipa: "ʈʂu",
		term: "[ju]ice"
	},
	zhua: {
		ipa: "ʈʂwa",
		term: "So[ju wa]ter"
	},
	zhuai: {
		ipa: "ʈʂwaɪ",
		term: "So[ju i]ce"
	},
	zhuan: {
		ipa: "ʈʂwan",
		term: "So[ju un]derwear"
	},
	zhuang: {
		ipa: "ʈʂwɑŋ",
		term: "So[ju en]voy"
	},
	zhui: {
		ipa: "ʈʂweɪ",
		term: "sewa[ge wa]ste"
	},
	zhun: {
		ipa: "ʈʂwən",
		term: "[jew win]"
	},
	zhuo: {
		ipa: "ʈʂwo",
		term: "wa[gewo]rker"
	},
	zi: {
		ipa: "ʦɹ̩",
		term: "ki[ds]"
	},
	zong: {
		ipa: "ʦʊŋ",
		term: "han[dsown g]love"
	},
	zou: {
		ipa: "ʦoʊ",
		term: "mi[dso]le"
	},
	zu: {
		ipa: "ʦu",
		term: "ku[dzu]"
	},
	zuan: {
		ipa: "ʦwan",
		term: "crow[d's un]rest"
	},
	zui: {
		ipa: "ʦweɪ",
		term: "da[d's wei]ght"
	},
	zun: {
		ipa: "ʦwən",
		term: "ban[d's un]agi"
	},
	zuo: {
		ipa: "ʦwo",
		term: "swor[dswo]man"
	}
};
export { pinyin_default as default };
